(function () {
  if(!document.querySelector('.wp-block-table.is-style-collapsible')) return this;
  const tables = document.querySelectorAll('.wp-block-table.is-style-collapsible');

  tables.forEach(table => {
    const caption = table.querySelector('figcaption');
    let isOpen = false;

    if (caption) {
      // 初期のaria属性を設定
      caption.setAttribute('role', 'button');
      caption.setAttribute('aria-expanded', 'false');
      caption.setAttribute('tabindex', '0');

      // 元のテキストを保持（クリック時に使う）
      const originalText = caption.textContent.trim();
      const openText = originalText;
      const closeText = originalText.replace('表示する', '表示しない');  // "表示"を"表示しない"に置換

      // クリックイベント
      caption.addEventListener('click', toggleTable);
      caption.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          toggleTable();
          e.preventDefault();  // Spaceキーのデフォルト動作を防ぐ
        }
      });

      function toggleTable() {
        isOpen = !isOpen;
        table.classList.toggle('is-open', isOpen);

        // テキストを変更
        caption.textContent = isOpen ? closeText : openText;

        // aria-expandedを更新
        caption.setAttribute('aria-expanded', isOpen);
      }
    }
  });


})();
